$(document).ready(function(){
  $(document).on('change keyup keydown paste', "#lb_dedication", function() {
    if($(this).val().length > 140){
      $(this).val($(this).val().slice(0,140));
    }
  });
  if($("#change_country_lb").length != 0){
    $("#country_hidden_lb").val("ES");
    var form = $("#change_country_lb").parents('form:first');
    form.submit();
  }
  $(document).on("click", "#country_list_lb", function(event){
    event.preventDefault();
    $(".selector_popup_lb").removeClass("lb-hide-element");
    $(".selector_popup_lb").addClass("flex_content_lb");
  })
  $(document).on("click", ".country_item_lb", function(event){
    $("#country_hidden_lb").val($(this).data("iso"));
    var form = $(this).parents('form:first');
    form.submit();
  })
  $(document).on("click", "#news_button_lb", function(event){
    if($(".lb_check_terms_button").prop('checked')) {
      $("#error_news_lb").fadeOut( "slow" );
    }else {
      event.preventDefault();
      $("#error_news_lb").fadeIn("slow");
    }
  });
  $(document).on("click", ".lb_check_terms_button", function(event){
    if($(this).prop('checked')) {
      $("#error_news_lb").fadeOut( "slow" );
    }
  });
  $(document).on("click", "#button_lb_buy", function(event){
    if($(".lb_check_terms_button_cart").prop('checked')) {
      $("#error_news_lb_cart").fadeOut( "slow" );
    }else {
      event.preventDefault();
      $("#error_news_lb_cart").fadeIn("slow");
    }
  });
  $(document).on("click", ".lb_check_terms_button_cart", function(event){
    if($(this).prop('checked')) {
      $("#error_news_lb_cart").fadeOut( "slow" );
    }
  });
  
  $(document).on("click", ".close_selector_lb", function(event){
    event.preventDefault();
    $(".selector_popup_lb").addClass("lb-hide-element");
    $(".selector_popup_lb").removeClass("flex_content_lb");
  })
  $(document).on({
    mouseenter: function () {
      $(this).find(".ProductItem__PriceList").addClass("lb_show_price_list");
    },
    mouseleave: function () {
      $(this).find(".ProductItem__PriceList").removeClass("lb_show_price_list");
    }
  }, ".lb_product_overflow");
  $("#lb_error_msg").hide();
  if($(".Header__CartCount").text()=== "0"){
    $(".Header__CartCount").hide();
  }
  $(".ProductForm__AddToCart").on("click", function(){
    $(".Header__CartCount").show();
  });
  $(document).on("click", ".CartItem__Remove", function () {
    var padDiv = parseInt($(this).parent().find(".QuantitySelector__CurrentQuantity").val());
    var cartT = parseInt($(".Header__CartCount").text());
    if((padDiv - cartT) === 0){
      $(".Header__CartCount").hide();
    }  
  });
  $(document).on("click", ".QuantitySelector__Button", function () {
    var padDiv = parseInt($(this).parent().find(".QuantitySelector__CurrentQuantity").val());
    var cartT = parseInt($(".Header__CartCount").text());
    if($('.CartItemWrapper').length > 1) {
      if((padDiv - cartT) === 0){
        $(".Header__CartCount").hide();
      }
    }else {
      if($(this).data("quantity") === 0){
        $(".Header__CartCount").hide();
      }
    } 
    
  });
  $('.lb-gift-card').on("click", function(){
    $('.lb-gift-card').removeClass('check_span');
    $(this).addClass('check_span');
  });
  /*$('body').on('click', '.lb_checkout_button', function() {
    if ($('#check_legal_cart').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Debes aceptar nuestra política de privacidad y los términos y condiciones");
      return false;
    }
  });*/
  $('body').on('click', '#button_news', function() {
    if ($('#check_legal').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Debes aceptar nuestra política de privacidad.");
      return false;
    }
  });
  $('body').on('click', '.lb_order_box', function() {
    if($('.lb_cart_container').hasClass("lb_hide_order")){
      $('.lb_cart_container').removeClass('lb_hide_order');
      $('#lb_order_note').prop('checked', true);
    }else{
      $('.lb_cart_container').addClass('lb_hide_order');
      $('#lb_order_note').prop('checked', false);
    }
  });
  $('body').on('click', '#lb_add_dedication', function() {
    checkProduct();
  });

  // Add to cart button
  $('body').on('click', '.btn_anadir_hover', function(e) {
    e.preventDefault();
    const productId = e.target.dataset['productId']
    if(!productId) return;

    let formData = {
      'items': [{
       'id': productId,
       'quantity': 1
       }]
     };
     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
       return response.json();
     })
     .then(data => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
        }));
        document.querySelector('[data-drawer-id="sidebar-cart"][data-action="open-drawer"]').click()
     })
     .catch((error) => {
       console.error('Error:', error);
     });
    jQuery.ajax({
      type: 'POST',
      url: `${window.Shopify.routes.root}cart/add.js`,
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
        }));
      }   
    }); 
  })

  $('body').on('click', '.CartItem__Remove', function() { 
    jQuery.getJSON('/cart.js', function(cart) {
      if (cart.item_count === 2 && (cart.items[0].id === 41125456969891 || cart.items[1].id === 41125456969891)) {
        
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
              quantity: 0,
              id: "41125456969891"
          },
          success: function (data){
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            window.history.go();
          }
        });
        
        
        //jQuery.post('/cart/update.js', 'updates[41125456969891]=0');
        
        
      }
    })
  });
  function checkProduct() {
    jQuery.getJSON('/cart.js', function(cart) {
        var check = false;
        $.each(cart.items, function (ind, elem) { 
          if(elem.id === 41125456969891) {
            check = true;
          }
        });
        if (!check) {
          addProduct();
        } else {
          $('#lb_error_msg').removeClass('lb_hide_message');
          $('#lb_error_msg').addClass('fade-in');
          setTimeout(function(){ $('#lb_error_msg').addClass('fade-out'); }, 2000);
          setTimeout(function(){ $('#lb_error_msg').addClass('lb_hide_message'); }, 4000);
          
        }
    } );
  }
  function addProduct(data) {
    if(!data) {
      data = {
        "id": "41125456969891",
        "quantity": "1",
         "properties": {
          'Dedication': $('#lb_dedication').val()
          }
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
        }));
      }   
    }); 
  }
});
